// Labs page — operator grid + admin slot management.
// Reuses the device action endpoints under /api/devices/<id>/...
// so the buttons behave the same as on the Devices page.

(function ($) {
  'use strict';

  // We register on body for the operator buttons (wake/shutdown/schedule/
  // cancel/light) because the SAME handlers serve the /labs/ slot cards
  // AND the /devices/<id>/connect/ controls panel. The admin slot-mgmt
  // handlers further down DO need #lab-root, but using a per-handler
  // guard (the handler returns if there's no slot context) is simpler
  // than splitting this file.
  var isLabsPage = $('#lab-root').length > 0;

  var BTN_PRIMARY = 'bg-orange-500 hover:bg-orange-600 text-white';
  var BTN_DANGER  = 'bg-red-500 hover:bg-red-600 text-white';

  function postForm(url, data) {
    return $.post(url, data || {});
  }

  // ---------- Status pill helpers ----------
  function statusPill(status) {
    if (status === 'online') {
      return '<span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs ' +
             'bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-300">' +
             '<span class="w-1.5 h-1.5 rounded-full bg-green-500"></span> Online</span>';
    }
    if (status === 'offline') {
      return '<span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs ' +
             'bg-red-100 text-red-700 dark:bg-red-900/40 dark:text-red-300">' +
             '<span class="w-1.5 h-1.5 rounded-full bg-red-500"></span> Offline</span>';
    }
    return '<span class="inline-flex items-center gap-1 px-2 py-0.5 rounded text-xs ' +
           'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-200">' +
           '<span class="w-1.5 h-1.5 rounded-full bg-slate-400"></span> Unknown</span>';
  }

  // ---------- 60s status polling (labs page only) ----------
  // Reuse the existing /api/devices/statuses/ endpoint. For each slot
  // that has a device, update its .slot-status pill in place.
  if (isLabsPage) {
    var refreshStatuses = function () {
      $.get('/api/devices/statuses/').done(function (resp) {
        if (!resp || !Array.isArray(resp.devices)) return;
        var byId = {};
        resp.devices.forEach(function (d) { byId[d.id_str] = d; });
        $('.lab-slot[data-device-id]').each(function () {
          var $slot = $(this);
          var info = byId[$slot.data('device-id')];
          if (!info) return;
          $slot.find('.slot-status').html(statusPill(info.status));
        });
      });
    };
    setInterval(refreshStatuses, 60000);
  }

  // ---------- Admin: add lab ----------
  $(document).on('click', '.lab-add-btn', function () {
    $.get('/api/labs/modal/add/', function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('New lab', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Create',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            postForm('/api/labs/add/', {
              name: $('#lab-name').val().trim(),
              slot_count: $('#lab-slot_count').val(),
            })
              .done(function (r) {
                if (r.ok) {
                  Toast.show('Lab created', 'success');
                  // Easiest reliable refresh: reload the page so the
                  // new lab section appears. (For Phase C+ we'd inject
                  // a rendered lab card via a new endpoint.)
                  location.reload();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Create'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
                lb.stop('Create');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Admin: rename lab ----------
  $(document).on('click', '.lab-rename-btn', function () {
    var labId = $(this).closest('.lab-card').data('lab-id');
    $.get('/api/labs/modal/rename/', { id: labId }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Rename lab', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Save',
          class: BTN_PRIMARY,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            postForm('/api/labs/' + labId + '/rename/', { name: $('#lab-name').val().trim() })
              .done(function (r) {
                if (r.ok) {
                  $('.lab-card[data-lab-id="' + labId + '"] .lab-name').text(r.name);
                  Toast.show('Renamed', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Save'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
                lb.stop('Save');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Admin: delete lab ----------
  $(document).on('click', '.lab-delete-btn', function () {
    var labId = $(this).closest('.lab-card').data('lab-id');
    $.get('/api/labs/modal/delete/', { id: labId }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Delete lab', resp.html, { size: 'sm' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Delete',
          class: BTN_DANGER,
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            postForm('/api/labs/' + labId + '/delete/')
              .done(function (r) {
                if (r.ok) {
                  $('.lab-card[data-lab-id="' + labId + '"]').remove();
                  Toast.show('Lab deleted', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Delete'); }
              })
              .fail(function () { Toast.show('Failed', 'error'); lb.stop('Delete'); });
          },
        },
      ]).show();
    });
  });

  // ---------- Admin: add slot to lab ----------
  $(document).on('click', '.lab-add-slot-btn', function () {
    var $lab = $(this).closest('.lab-card');
    var labId = $lab.data('lab-id');
    postForm('/api/labs/' + labId + '/add-slot/')
      .done(function (r) {
        if (r.ok) {
          $lab.find('.lab-slots').append(r.slot_html);
          Toast.show('Slot added', 'success');
        } else { Toast.show(r.error || 'Failed', 'error'); }
      })
      .fail(function () { Toast.show('Failed', 'error'); });
  });

  // ---------- Admin: assign device to slot ----------
  $(document).on('click', '.lab-slot-assign-btn', function () {
    var $slot = $(this).closest('.lab-slot');
    var slotId = $slot.data('slot-id');
    $.get('/api/labs/slot/' + slotId + '/modal/assign/', function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Assign device to slot', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Assign',
          class: BTN_PRIMARY,
          onClick: function () {
            var deviceId = $('#slot-device_id').val();
            if (!deviceId) { Toast.show('Pick a device', 'error'); return; }
            var lb = new LoadingButton(this); lb.start();
            postForm('/api/labs/slot/' + slotId + '/assign/', { device_id: deviceId })
              .done(function (r) {
                if (r.ok) {
                  $slot.replaceWith(r.slot_html);
                  Toast.show('Device assigned', 'success');
                  dlg.hide();
                } else { Toast.show(r.error || 'Failed', 'error'); lb.stop('Assign'); }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
                lb.stop('Assign');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Admin: unassign device from slot (X on filled slot) ----------
  $(document).on('click', '.lab-slot-unassign-btn', function () {
    var $slot = $(this).closest('.lab-slot');
    var slotId = $slot.data('slot-id');
    if (!confirm('Unassign the device from this slot?')) return;
    postForm('/api/labs/slot/' + slotId + '/unassign/')
      .done(function (r) {
        if (r.ok) {
          $slot.replaceWith(r.slot_html);
          Toast.show('Device unassigned', 'success');
        } else { Toast.show(r.error || 'Failed', 'error'); }
      })
      .fail(function () { Toast.show('Failed', 'error'); });
  });

  // ---------- Admin: remove empty slot ----------
  $(document).on('click', '.lab-slot-remove-btn', function () {
    var $slot = $(this).closest('.lab-slot');
    var slotId = $slot.data('slot-id');
    if (!confirm('Remove this slot?')) return;
    postForm('/api/labs/slot/' + slotId + '/remove/')
      .done(function (r) {
        if (r.ok) {
          $slot.remove();
          Toast.show('Slot removed', 'success');
        } else { Toast.show(r.error || 'Failed', 'error'); }
      })
      .fail(function () { Toast.show('Failed', 'error'); });
  });

  // The operator buttons (wake / shutdown / schedule / cancel / light)
  // work on both /labs/ slots AND the /devices/<id>/connect/ page header.
  // We find the device id via the nearest [data-device-id] ancestor --
  // matches `.lab-slot` AND `#connect-root`. Same handler, both contexts.
  function nearestDeviceId(el) {
    return $(el).closest('[data-device-id]').data('device-id');
  }
  function nearestDeviceName(el) {
    var $c = $(el).closest('[data-device-id]');
    return $c.data('device-name') ||
           $c.find('.font-medium').first().text().trim() ||
           'this device';
  }

  // Swap the schedule/cancel icon + show/hide the countdown badge after
  // the operator schedules or cancels. fire_at='' means "cancelled".
  // Works on whichever page the originating button lives on:
  //   - /devices/                   row buttons (.device-schedule-btn handled in device.js)
  //   - /labs/                      slot buttons + slot-status / countdown
  //   - /devices/<id>/connect/      header countdown + controls panel
  function applyScheduleChange(deviceId, fireAtIso) {
    // 1. Lab slot button bar + countdown row.
    $('.lab-slot[data-device-id="' + deviceId + '"]').each(function () {
      var $slot = $(this);
      var $sched = $slot.find('.lab-schedule-btn');
      var $cancel = $slot.find('.lab-cancel-schedule-btn');
      if (fireAtIso) {
        if ($sched.length) {
          $sched.replaceWith(
            '<button class="lab-cancel-schedule-btn group flex flex-col items-center justify-center gap-0.5 py-2 ' +
            'text-[10px] font-semibold uppercase tracking-wide ' +
            'text-amber-600 hover:bg-amber-50 hover:text-red-600 active:bg-amber-100 ' +
            'dark:text-amber-300 dark:hover:bg-red-500/10 dark:hover:text-red-300 transition-colors" ' +
            'title="Cancel scheduled shutdown">' +
            '<i class="bi bi-clock-fill text-base group-hover:scale-110 transition-transform"></i>Cancel</button>'
          );
        }
        // Show + populate the slot's shutdown countdown row.
        $slot.find('.slot-shutdown-row').removeClass('hidden');
        $slot.find('.slot-shutdown-countdown').attr('data-fire-at', fireAtIso);
      } else {
        if ($cancel.length) {
          $cancel.replaceWith(
            '<button class="lab-schedule-btn group flex flex-col items-center justify-center gap-0.5 py-2 ' +
            'text-[10px] font-semibold uppercase tracking-wide ' +
            'text-slate-600 hover:bg-amber-50 hover:text-amber-700 active:bg-amber-100 ' +
            'dark:text-zinc-300 dark:hover:bg-amber-500/10 dark:hover:text-amber-300 transition-colors" ' +
            'title="Schedule shutdown">' +
            '<i class="bi bi-clock text-base group-hover:scale-110 transition-transform"></i>Schedule</button>'
          );
        }
        // Hide the countdown row + clear the data attribute.
        $slot.find('.slot-shutdown-row').addClass('hidden');
        $slot.find('.slot-shutdown-countdown').attr('data-fire-at', '');
      }
    });

    // 2. Connect-page controls panel + top-bar countdown badge.
    if ($('#connect-root').data('device-id') === deviceId) {
      var $sched = $('#connect-root .lab-schedule-btn');
      var $cancel = $('#connect-root .lab-cancel-schedule-btn');
      if (fireAtIso) {
        if ($sched.length) {
          $sched.replaceWith(
            '<button class="lab-cancel-schedule-btn group flex flex-col items-center justify-center gap-0.5 py-2 ' +
            'text-[10px] font-semibold uppercase tracking-wide ' +
            'text-amber-600 hover:bg-amber-50 hover:text-red-600 active:bg-amber-100 ' +
            'dark:text-amber-300 dark:hover:bg-red-500/10 dark:hover:text-red-300 transition-colors" ' +
            'title="Cancel scheduled shutdown">' +
            '<i class="bi bi-clock-fill text-base group-hover:scale-110 transition-transform"></i>Cancel</button>'
          );
        }
      } else {
        if ($cancel.length) {
          $cancel.replaceWith(
            '<button class="lab-schedule-btn group flex flex-col items-center justify-center gap-0.5 py-2 ' +
            'text-[10px] font-semibold uppercase tracking-wide ' +
            'text-slate-600 hover:bg-amber-50 hover:text-amber-700 active:bg-amber-100 ' +
            'dark:text-zinc-300 dark:hover:bg-amber-500/10 dark:hover:text-amber-300 transition-colors" ' +
            'title="Schedule shutdown">' +
            '<i class="bi bi-clock text-base group-hover:scale-110 transition-transform"></i>Schedule</button>'
          );
        }
      }
      var $countdown = $('#connect-shutdown-countdown');
      if ($countdown.length) {
        if (fireAtIso) {
          $countdown.attr('data-fire-at', fireAtIso).removeClass('hidden');
        } else {
          $countdown.attr('data-fire-at', '').addClass('hidden');
        }
      }
    }

    // 3. Devices-list row (delegate to device.js if it's on the page).
    var $row = $('#device-tbody tr[data-id="' + deviceId + '"]');
    if ($row.length) {
      var $cd = $row.find('.row-shutdown-countdown');
      if (fireAtIso) {
        $cd.attr('data-fire-at', fireAtIso)
           .removeClass('text-slate-400')
           .addClass('text-amber-700 dark:text-amber-300')
           .html('<i class="bi bi-clock-history"></i> <span class="countdown-value">…</span>');
        $row.find('.device-schedule-btn').replaceWith(
          '<button class="device-cancel-schedule-btn p-1.5 text-amber-600 hover:text-red-600" ' +
          'title="Cancel scheduled shutdown"><i class="bi bi-clock-fill"></i></button>'
        );
      } else {
        $cd.attr('data-fire-at', '').html('');
        $row.find('.device-cancel-schedule-btn').replaceWith(
          '<button class="device-schedule-btn p-1.5 text-slate-500 hover:text-amber-600" ' +
          'title="Schedule shutdown"><i class="bi bi-clock"></i></button>'
        );
      }
    }

    // 4. Re-tick the countdown ticker so the value renders immediately.
    if (window.tickShutdownCountdowns) window.tickShutdownCountdowns();
  }

  // ---------- Operator: wake (reuses /api/devices/<id>/wake/) ----------
  $(document).on('click', '.lab-wake-btn', function () {
    var deviceId = nearestDeviceId(this);
    if (!deviceId) return;
    postForm('/api/devices/' + deviceId + '/wake/')
      .done(function (r) {
        Toast.show(r.ok ? 'WoL packet sent' : (r.error || 'Failed'),
                   r.ok ? 'success' : 'error');
      })
      .fail(function () { Toast.show('Failed', 'error'); });
  });

  // ---------- Operator: shutdown ----------
  $(document).on('click', '.lab-shutdown-btn', function () {
    var deviceId = nearestDeviceId(this);
    if (!deviceId) return;
    var name = nearestDeviceName(this);
    if (!confirm('Shutdown ' + name + ' now?')) return;
    postForm('/api/devices/' + deviceId + '/shutdown/')
      .done(function (r) {
        Toast.show(r.ok ? 'Shutdown command sent' : (r.error || 'Failed'),
                   r.ok ? 'success' : 'error');
      })
      .fail(function (xhr) {
        Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
      });
  });

  // The .lab-light-btn click is handled in device-lights.js (opens the
  // per-device lights popover).

  // ---------- Locked buttons: show a 'X is using' toast on click ----------
  // The disabled attribute already blocks the action; this captures the
  // click and tells the user WHY it's disabled.
  $(document).on('click', '.lab-locked-connect-btn, button[data-locked-by]',
    function (e) {
      var who = $(this).attr('data-locked-by');
      if (who) {
        e.preventDefault();
        Toast.show(who + ' is using this device', 'error');
      }
    });

  // ---------- Operator: schedule shutdown (mirrors device row) ----------
  $(document).on('click', '.lab-schedule-btn', function () {
    var deviceId = nearestDeviceId(this);
    if (!deviceId) return;
    $.get('/api/devices/modal/schedule/', { id: deviceId }, function (resp) {
      if (!resp.ok) { Toast.show(resp.error || 'Failed', 'error'); return; }
      var dlg = new Dialog('Schedule shutdown', resp.html, { size: 'md' });
      dlg.setButtons([
        { name: 'Cancel', dismiss: true },
        {
          name: 'Schedule',
          class: 'bg-orange-500 hover:bg-orange-600 text-white',
          onClick: function () {
            var lb = new LoadingButton(this); lb.start();
            var fireAt = $('#device-fire_at').val();
            if (!fireAt) { Toast.show('Pick a time', 'error'); lb.stop('Schedule'); return; }
            var fireAtUtc = new Date(fireAt).toISOString();
            $.post('/api/devices/' + deviceId + '/schedule/', { fire_at: fireAtUtc })
              .done(function (r) {
                if (r.ok) {
                  Toast.show('Shutdown scheduled', 'success');
                  // Server returns the scheduled fire_at (UTC ISO); use it
                  // to live-update every page that's showing this device.
                  applyScheduleChange(deviceId, (r.scheduled && r.scheduled.fire_at) || fireAtUtc);
                  dlg.hide();
                } else {
                  Toast.show(r.error || 'Failed', 'error'); lb.stop('Schedule');
                }
              })
              .fail(function (xhr) {
                Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
                lb.stop('Schedule');
              });
          },
        },
      ]).show();
    });
  });

  // ---------- Operator: cancel scheduled shutdown ----------
  $(document).on('click', '.lab-cancel-schedule-btn', function () {
    var deviceId = nearestDeviceId(this);
    if (!deviceId) return;
    var name = nearestDeviceName(this);
    if (!confirm('Cancel the scheduled shutdown for ' + name + '?')) return;
    $.post('/api/devices/' + deviceId + '/cancel-schedule/')
      .done(function (r) {
        if (r.ok) {
          Toast.show('Scheduled shutdown cancelled', 'success');
          applyScheduleChange(deviceId, '');
        } else {
          Toast.show(r.error || 'Failed', 'error');
        }
      })
      .fail(function (xhr) {
        Toast.show((xhr.responseJSON && xhr.responseJSON.error) || 'Failed', 'error');
      });
  });

})(jQuery);
